<template>
  <div id="live">
    <!-- <div class="notice amjs-wrapper">
      <Notice :list="noticeList"></Notice>
    </div> -->
    <div class="main">
      <div class="left" @click="transLeft(1)"></div>
      <div class="right" @click="transLeft(0)"></div>
      <div class="wrapper">

        <ul :style="'width:'+(list.length*210+145)+'px;min-width:1195px;transition:all .5s;color:red;transform:translateX('+leftLate+'px);'">
          <li
            v-for="(item, index) in list"
            :key="index"
            @mouseenter="enter(index)"
            :class="{ active: active == index }"
            @click="getToken(item,2)"
          >
            <div class="normal">
              <div class="title" :class="{'actTitle':active == index}">{{item.name}}</div>
              <div class="img">
                <img loading="lazy" v-lazy="item.imgUrl?item.imgUrl:default_list[0].img" alt="">
              </div>
              <div class="intro animate__animated animate__fadeInUp" v-show=" active == index ">
                {{(item.name === 'TG视讯' || item.nameEn === 'TG') ? '主播、荷官双模式，透明桌面、多台投注' : introList[index%introList.length].info}}
              </div>
              <div class="enter" v-show=" active == index "></div>
            </div>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
// import Notice from "../../components/notice";
export default {
  name: "component_name",
  components: {
    // Notice,
  },
  data() {
    return {
      leftLate:0, // 位移
      active: 0,
      noticeList: [],
      default_list:[
        {img:require('@/assets/images/mb/live-bg1.png')},
        // {img:require('@/assets/images/mb/live-bg2.png')},
        // {img:require('@/assets/images/mb/live-bg3.png')},
        // {img:require('@/assets/images/mb/live-bg4.png')},
        // {img:require('@/assets/images/mb/live-bg5.png')},
        // {img:require('@/assets/images/mb/live-bg6.png')},
        // {img:require('@/assets/images/mb/live-bg7.png')},
        // {img:require('@/assets/images/mb/live-bg8.png')},
        // {img:require('@/assets/images/mb/live-bg9.png')},
        // {img:require('@/assets/images/mb/live-bg10.png')},
      ],
      
      list: [],
    };
  },
  computed:{
    introList(){
      return [
        {info:this.$t('secondGame.intro1')},
        {info:this.$t('secondGame.intro2')},
        {info:this.$t('secondGame.intro3')},
        {info:this.$t('secondGame.intro4')},
      ]
    }
  },
  mounted(){
    this.getDataType()
  },
  methods: {
    // 进入游戏
        getToken: async function(req,index) {
            let self = this;
                var issafariBrowser = /Safari/.test(navigator.userAgent) && !/Chrome/.test(navigator.userAgent);
                
            if (!self.$common.getUser()) {
                self.$message.warning(self.$t('indexPage.pleaseLogin'))
                return
            }
            self.tenantId = self.$common.getUser().tenant_id
            self.username = self.$common.getUser().username
            self.uid = self.$common.getUser().user_id
            let datas = {
                tenantId: self.tenantId,
                username: self.username,
                gameId: index == 2?req.ids:req.id,
                clientIp: self.$config.clientIp,
                memberId: self.uid,
                terminalType: 1
            }
            self.$common.setGameRequestData(datas)
            
            const res = await self.$http.post(this.$api.getToken, datas, true)
            if (res.code == 0) {
                self.gameUrl = res.data;
                if (req.openMode === 1) {
                // if(issafariBrowser) {
                    //  self.winOpen.location.href = self.gameUrl;
                // }else{
                    window.open(self.gameUrl)
                // }
                
                }else{
                    window.open(self.gameUrl)
                }

            } else {
              self.$message.error(self.$t('indexPage.repair'))
                // if (req.openMode === 1) {
                // window.open('/error.html?type=1')
                // // self.winOpen.location.href = '/error.html?type=1';
                // }
                
                // if (req.status === 0) {
                // self.$message.error(self.$t('indexPage.repair'))
                // }else{
                // self.$message.error(self.$t('indexPage.failed'))
                // }
            }
        },
    // 获取数据列表
    getDataType(){
      let result = JSON.parse(localStorage.getItem('game_menus_pc'));
      this.list = result.data.zb;
    },
    transLeft(val){
      let num = this.list.length*210+145 - 1195
      if(val == 0){
        if(this.leftLate - 210 + num > 0){
          this.leftLate -= 210;
        }else{
          this.leftLate = -num;
        }
      }
      else {
        if(this.leftLate + 210 > 0){
          this.leftLate = 0;
        }else {
          this.leftLate += 210
        }
      }
    },
    enter(index) {
      this.active = index;
    },
  },
};
</script>

<style lang="scss" scoped>
#live {
  padding-top: 540px;
  padding-bottom: 20px;
  background: #000 url(../../static/image/pn/live.jpg) no-repeat;
  background-position: center top;
  background-size: cover;
  
  .main {
    position: relative;
    height: 300px;
    width: 1400px;
    margin: 0 auto;
    box-sizing: border-box;
    padding: 0 100px;
    // overflow-x:auto;
    .left {
      position: absolute;
      left: 20px;
      top: 50%;
      width: 50px;
      height: 50px;
      color:#fff;
      z-index:100;
      cursor:pointer;
      background: url('../../assets/images/mb/left-icon.png') no-repeat;
      background-size: contain;
    }
    .right {
      position: absolute;
      right: 20px;
      top: 50%;
      width: 50px;
      height: 50px;
      color:#fff;
      z-index:100;
      cursor:pointer;
      background: url('../../assets/images/mb/right-icon.png') no-repeat;
      background-size: contain;
    }
    .wrapper {
      width: 1195px;
      height: 300px;
      overflow: auto;
      &::-webkit-scrollbar {
        display: none; /* Chrome Safari */
      }
      ul {
        position: relative;
        margin: 0 auto;
        display: flex;
        height: 100%;
        white-space: nowrap;
        li {
          position: relative;
          width: 210px;
          box-sizing: border-box;
          transition: all 0.3s;
          background: url('../../assets/images/mb/live_bg.png') no-repeat;
          background-size: cover;
          border-left: 2px solid #080808;
          position: relative;
          .normal {
              position: relative;
              width: 100%;
              height: 100%;
              cursor: pointer;
            .title {
              position: absolute;
              width: 120px;
              height: 30px;
              line-height: 30px;
              font-size:22px;
              font-weight:normal;
              text-align: center;
              right: 10px;
              top: 40px;
              background-image: linear-gradient(180deg,#ccc9e6,#937ce7);
              -webkit-background-clip:text;
              color: transparent;
              overflow: hidden;
              white-space: nowrap;
              text-overflow: ellipsis;
              
            }
            .actTitle {
              text-align: left;
            }
            .img {
              position: absolute;
              left: 0;
              bottom: 0;
              width: 210px;
              img {
                width: 100%;
                height: 100%;
                object-fit: contain;
                object-position: left bottom;
              }
            }
            .intro {
              position: absolute;
              right: 0;
              bottom: 190px;
              width: 100%;
              box-sizing: border-box;
              padding: 0 10px;
              height: 30px;
              // border:1px solid gold;
              // border-radius:24px;
              font-size: 16px;
              color:white;
              text-shadow: 1px 1px 0 #da83ff;
            
              text-align: right;
              line-height: 30px;
            }
            .enter {
              position: absolute;
              right: 30px;
              bottom: 100px;
              width: 130px;
              height: 48px;
              // border:1px solid gold;
              border-radius:24px;
              background: url('../../assets/images/mb/enter1.png') no-repeat;
              background-size: cover;
              text-align: center;
              line-height: 48px;
            }
          }
        }
  
        li.active {
          width: 355px;
          overflow: hidden;
          background: url(../../static/image/pn/activeBg.jpg) no-repeat;
          .title {
            right: 90px;
            font-weight: bold;
            font-size:26px;
            background-image: 0 none;
            color: #fff;
            text-shadow: 1px 1px 0 #e99b65;
          }
        }
      }
    }
    }
  .seamless-warp3 {
        overflow: hidden;
        height: 140px;
        width: 140px * 4;
        margin: 0 auto;
        .left-arrow, .right-arrow {
            position: relative;
            display: inline-block;
            width: 40px;
            height: 40px;
            border-radius: 50%;
            background-color: #00a0e9;
            cursor: pointer;
            &:hover {
                background-color: #0f39fa;
            }
            &::before {
                position: absolute;
                content: '';
                width: 16px;
                height: 16px;
                top: 12px;
                left: 15px;
                border: 2px solid #fff;
            }
        }
        .left-arrow::before {
            border-right: 0;
            border-bottom: 0;
            transform: rotate(-45deg);
        }
        .right-arrow::before {
            border-left: 0;
            border-top: 0;
            left: 9px;
            transform: rotate(-45deg);
        }
        ul.item {
            width: 140px * 8;
            li {
                float: left;
                width: 120px;
                height: 120px;
                margin: 10px;
                line-height: 120px;
                background-color: #999;
                color: #fff;
                text-align: center;
                font-size: 30px;
            }
        }
    }
}
</style>
